
import { useAuth } from '@/store/auth';
import UploaderPage from '@/pages/UploaderPage';

export default function FacilityUploadTab() {
  const { user } = useAuth();

  if (!user || user.role !== 'facility') {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <p className="text-red-600">Access denied. Facility account required.</p>
        </div>
      </div>
    );
  }

  // Use the existing UploaderPage component which already handles facility-specific uploads
  return <UploaderPage />;
}
